module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"current":"当月","previous":"前月","lastYear":"昨年同月","lastYearPrevious":"昨年前月"},"en":{"current":"Current Month","previous":"Previous Month","lastYear":"Same Month Last Year","lastYearPrevious":"Previous Month Last Year"}}')
  delete Component.options._Ctor
}
